module.exports = __webpack_public_path__ + "static/media/recipient-template-open-platform.6d855e3a.xlsx";